import {toast, Toaster} from 'react-hot-toast';
import React, { useEffect, useState, useRef } from 'react';
import { DefaultSelect, FullCalendar, InformationDiv } from 'ui-kit-takeat';
import Dashboard from './Dashboard';
import logoImg from '../assets/Union.png'
import {Button} from 'ui-kit-takeat';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'takeat-design-system-ui-kit';
import { Select } from 'takeat-design-system-ui-kit';
import { Dropdown,Spinner } from 'takeat-design-system-ui-kit';
import { Link } from 'react-router-dom';
import { SimpleTable } from 'ui-kit-takeat';
import ApiData from "../ApiData"; // Importa a API padrão
import ApiDataClub from "../ApiDataClub"; // Importa a API para o "club"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Loading from './Loading';
import CohortChart from './CohortChart';
import TableComponent from './SucessTable';
const Sucesso = () => {

  const[activeTab,setActiveTab] = useState("table");
  const[tableFilters,setTableFilters] = useState({
    name: "",
    city: "",
    state: "",
    email: "",
    plano: "",
  });
  const[cohortData, setCohortData] = useState({});
  const [data, setData] = useState([]); // Armazena os dados combinados
  const [loading, setLoading] = useState(true); // Indica se ainda está carregando
  const [processedRequests, setProcessedRequests] = useState(0);
  const {logout} = useAuth();
  const navigate = useNavigate();
  const controller = new AbortController(); // Para abortar requisições se necessário
  const[cohortYear, setCohortYear] = useState(new Date().getFullYear());
  const [filters, setFilters] = useState({
    only_not_deleted: false,
    is_inactive: false,
    only_club_stores: false,
    fat_0_30: false

  });
  const[butao,setButao] = useState();
  const handleLogout= () =>{
    logout();
    navigate('/login');

  };

    const handleTableFilterChange = (e,key) => {
      setTableFilters({...tableFilters,[key]: e.target.value});

    }

    



    const handleFilterChange = (e) => {
    const { name, checked } = e.target;
    setFilters
    // Atualiza o filtro selecionado
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: checked

    }));
  };
console.log("Cohort Year", cohortYear.toString());



const availableYears = Object.keys(cohortData);
  useEffect(() => {
    const controller = new AbortController();

    
    
    const fetchData = async () => {
        try {
            // 🔹 Requisição principal
            const mainData = await ApiData.post({}, "sucess/main", controller.signal);
            const mergedData = {};
            const cohortData = await ApiData.post( {}, "sucess/cohort", controller.signal );

 
            setCohortData(cohortData);

            setLoading(false);

              Object.keys(cohortData).forEach((key) => {
                console.log(`🔑 Key: ${key} | 📦 Value:`, cohortData[key]);
                
              });
               // Exibe os valores do objeto
              
            
            // 🔹 Inicializa os dados com a requisição principal
            mainData.restaurants.forEach((item) => {
                mergedData[item.restaurant_id] = { ...item, last_created_at: "-" };
            });

            setData(Object.values(mergedData))// 🔥 Exibe mainData imediatamente
            
            const mergeById = (source, key, secondaryKey = null) => {
              if (!source || source.length === 0) return;

              source.forEach((item) => {
                  let id = item[key];

                  if (key === "restaurant_token" && secondaryKey) {
                      const match = Object.values(mergedData).find(rest => rest.token === item[key]);
                      if (match) id = match.restaurant_id;
                  }

                  if (id && mergedData[id]) {
                      const updatedData = { ...mergedData[id], ...item };

                      updatedData.comandas = (mergedData[id].comandas || 0) + (item.comandas || 0);
                      updatedData.comandas_fechadas = (mergedData[id].comandas_fechadas || 0) + (item.comandas_fechadas || 0);

                      if (item.last_created_at) {
                          const currentLast = mergedData[id].last_created_at;
                          updatedData.last_created_at =
                              currentLast === "-" || new Date(item.last_created_at) > new Date(currentLast)
                                  ? item.last_created_at
                                  : currentLast;
                      }

                      mergedData[id] = updatedData;
                  }
              });

              setData([...Object.values(mergedData)]); // Atualiza a tabela progressivamente
              
              setProcessedRequests(prev => prev + 1);
                 
             
          };
          
          

            // 🔹 Processa `club/sucess` separadamente antes das demais requisições
            try {
                const clubResponse = await ApiDataClub.post({}, "club/sucess", controller.signal);
                if (clubResponse && Object.keys(clubResponse).length > 0) {
                    const clubDataKey = Object.keys(clubResponse)[0];
                    
                    mergeById(clubResponse[clubDataKey], "restaurant_token", "token");
                }
            } catch (error) {
                console.error("Erro ao buscar club/sucess:", error);
            }

            // 🟢 Dispara as outras requisições de forma assíncrona
            const additionalRequests = [
              { api: ApiData, endpoint: "sucess/financial30", key: "restaurant_id" },
              { api: ApiData, endpoint: "sucess/financial60", key: "restaurant_id" },
              { api: ApiData, endpoint: "sucess/financial90", key: "restaurant_id" },
              { api: ApiData, endpoint: "sucess/fiscal", key: "restaurant_id" },
          ];

          await Promise.allSettled(
              additionalRequests.map(async ({ api, endpoint, key }) => {
                  try {
                      const response = await api.post({}, endpoint, controller.signal);
                      if (response && Object.keys(response).length > 0) {
                          const dataKey = Object.keys(response)[0];
                          mergeById(response[dataKey], key);
                          
                          
                      }
                  } catch (error) {
                      console.error(`Erro ao buscar ${endpoint}:`, error);
                  }
              })
          );

          
          
          

      } catch (error) {
          console.error("Erro ao buscar mainData:", error);
          setLoading(false);
          setCohortData({});
          console.error("Error fetching club/success:", error);
      }
  };

  fetchData();
 
  return () => controller.abort(); // Cancela requisições ao desmontar o componente
}, []);



const formatarData = (data) => {
  if (data === "-") return "-"; // Se não houver data, retorna "-"
 
  const dateObj = new Date(data);
  
  // Ajustando para o fuso horário correto
  return dateObj.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit" 
  }).replace(",", ""); 
};

// Função para baixar os dados como arquivo .xlsx
const handleDownload = () => {

  // Cria um array com os dados da tabela
  const worksheetData = filteredRestaurants.map((item) => ({
    "Username": item.name || "-",
    "MRR": typeof item.mrr === "number" ? item.mrr: "-",
    "Cidade" : item.city || "-",
    "Estado" :item.state || "-",
    "Email": item.email || "-",
    "WhatsApp Dono": item.owner_wpp || "-",
    "Plano": item.plano || "-",
    "Faturamento 0-30d": typeof item.faturamento_30_0 === "number" ? item.faturamento_30_0 : "-",
    "Faturamento 30-60d": typeof item.faturamento_60_30 === "number" ? item.faturamento_60_30 : "-",
    "Faturamento 60-90d": typeof item.faturamento_90_60 === "number" ? item.faturamento_90_60 : "-",
    "Últ. Comanda": formatarData( item.last_created_at ) || "-",
    "# Comandas Criadas (90d)": item.comandas || "-",
    "# Comandas Fechadas (90d)": item.comandas_fechadas || "-",
    "Tem Fiscal?": item.fiscal? "SIM":"NÃO",
    "# Notas Emitidas": item.total_nfces || "-",
    "Tem Clube?": item.token?"SIM":"NÃO",
    "# Clientes Pontuados": item.clients || "-",
    "# Resgates": item.rescues || "-",
}));


  // Cria um workbook e um worksheet do Excel
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Restaurantes");

  // Converte para um arquivo Excel e faz o download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });

  const currentDate = new Date().toLocaleDateString("pt-BR").replace(/\//g, "-"); 
  saveAs(file, `relatorio_restaurantes_${currentDate}.xlsx`);
  
};


const sortedData = [...data].sort((a, b) => {
  const dateA = a.last_created_at && a.last_created_at !== "-" ? new Date(a.last_created_at) : null;
  const dateB = b.last_created_at && b.last_created_at !== "-" ? new Date(b.last_created_at) : null;

  // Se ambos têm data, ordena do mais recente para o mais antigo
  if (dateA && dateB) return dateB - dateA;

  // Se apenas A não tem data, A vai para o final
  if (!dateA) return 1;

  // Se apenas B não tem data, B vai para o final
  if (!dateB) return -1;

  return 0;
});
const filteredRestaurants = sortedData.filter((item) => {
  const { only_not_deleted, only_club_stores, is_inactive, fat_0_30 } = filters;
  const { name, city, state, email, plano } = tableFilters;

  return (
    // 🔹 Filtros de Checkbox
    (!only_not_deleted || (item.is_deleted !==1)) &&
    (!only_club_stores || item.clients != null) &&
    (!is_inactive ||
      item.faturamento_30_0 != null ||
      item.faturamento_60_30 != null ||
      item.faturamento_90_60 != null) &&
    (!fat_0_30 || (item.faturamento_30_0 < 30000)) &&

    // 🔹 Filtros de Texto (Evita erro se valor for null/undefined)
    (name === "" || (item.name && item.name.toLowerCase().includes(name.toLowerCase()))) &&
    (city === "" || (item.city && item.city.toLowerCase().includes(city.toLowerCase()))) &&
    (state === "" || (item.state && item.state.toLowerCase().includes(state.toLowerCase()))) &&
    (email === "" || (item.email && item.email.toLowerCase().includes(email.toLowerCase()))) &&
    (plano === "" || (item.plano && item.plano.toLowerCase().includes(plano.toLowerCase())))
  );
});


if(loading){
  return(
  <div >
    <Loading/>
  </div>
  )
}

return(
  <div className="background">
  {/* 🔹 Header com Menu Dropdown */}


  {/* 🔹 Corpo do Conteúdo */}
  <div
    style={{
      overflow: "auto",
      width: "100%",
      display: "flex",
      flexDirection: "column",
    }}
  >
    <h1 className='sucesso-title'> Sucesso</h1>

    {/* 🔹 Navbar para alternar entre Tabela e Cohort */}
    <nav className="navbar">
    <button
        className={activeTab === "table" ? "active" : ""}
        onClick={() => setActiveTab("table")}
      >
        📋 Tabela
      </button>

      <button
        className={activeTab === "cohort" ? "active" : ""}
        onClick={() => setActiveTab("cohort")}
      >
        📊 Cohort
      </button>

    </nav>

    {/* 🔹 Renderiza Tabela */}
    {activeTab === "table" && (
      <TableComponent
        filters={filters}
        handleFilterChange={handleFilterChange}
        handleTableFilterChange={handleTableFilterChange}
        processedRequests={processedRequests}
        filteredRestaurants={filteredRestaurants}
        handleDownload={handleDownload}
        formatarData={formatarData}
      />
    )}

    {/* 🔹 Renderiza Gráfico de Cohort */}
    {activeTab === "cohort" && (
      <div className="cohort_chart">
        <h1 className='mean-sized-title'>Gráfico de Cohort - Restaurantes</h1>
        <CohortChart
          data={cohortData[cohortYear]}
          cohortYear={cohortYear}
          setCohortYear={setCohortYear}
          availableYears={availableYears}
        />
      </div>
    )}
  </div>
</div>
);
};

export default Sucesso;
